import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrintAssetVehicleLinkComponent } from './print-asset-vehicle-link/print-asset-vehicle-link.component';
import { PrintAssetVehicleLandingComponent } from './print-asset-vehicle-landing/print-asset-vehicle-landing.component';

const routes: Routes = [
  {
    path: '', component: PrintAssetVehicleLinkComponent,
    children: [
      { path: 'printBuildingVehicleQRDetail', component: PrintAssetVehicleLandingComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrintVehicleQrRoutingModule { }
